<template>
    <div class="payment-method-form-container">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="d-flex flex-column">
            <input
                v-model="cardInfo.nickname"
                type="text"
                name="nickname"
                placeholder="Nickname"
            />
            <input
                v-model="cardInfo.cardholderName"
                @input="validationCardHolder()"
                @blur="getFirstLast()"
                type="text"
                name="cardholderName"
                placeholder="Cardholder Name *"
                :class="{
                    'error-field': validateRules.cardholderName,
                    'input-border': !validateRules.cardholderName
                }"
                required
            />
        </div>
        <div v-if="op === 'create'" class="card-number-input">
            <input
                v-model.trim="cardInfo.cardNumber"
                class="w-100"
                @input="validationCardNumber()"
                @blur="getLastFour()"
                @keyup.delete="checkCard = false"
                maxlength="25"
                v-mask="'#### #### #### #### ###'"
                type="text"
                name="cardNumber"
                placeholder="Card Number *"
                :class="{
                    'error-field': validateRules.cardNumber,
                    'input-border': !validateRules.cardNumber
                }"
                required
            />
        </div>
        <div v-else class="card-number-input">
            <input
                :placeholder="`ending in ${paymentMethod.last_four}`"
                type="text"
                class="w-100"
                disabled
            />
        </div>
        <div class="card-meta-fields">
            <div class="exp-month-input">
                <input
                    v-model="cardInfo.expDate"
                    :class="{
                        'error-field': validateRules.expDate,
                        'input-border': !validateRules.expDate
                    }"
                    @input="validationExpDate()"
                    type="text"
                    v-mask="'##/##'"
                    name="expDate"
                    placeholder="Expiration date: MM / YY *"
                    required
                />
            </div>
            <div class="card-cvc-input">
                <input
                    v-model="cardInfo.cvc"
                    :class="{
                        'error-field': validateRules.cvc,
                        'input-border': !validateRules.cvc
                    }"
                    @input="validationCVC()"
                    type="text"
                    name="cvc"
                    placeholder="CVC *"
                    required
                    v-mask="'####'"
                />
            </div>
        </div>
        <button @click.prevent="handleSubmit" class="new-payment-method-btn save-card-btn">
            <span class="save-card-text">Save card</span>
        </button>
        <button @click="handleCancel" class="new-payment-method-btn mx-2 cancel-btn">
            <span class="cancel-text">Cancel</span>
        </button>
    </div>
</template>
<script>
    import axios from 'axios'
    import useNotification from '@/composables/useNotification.js'
    import { creditCardsValidation } from '../../mixins/credit-card-validation'

    export default {
        name: 'CardForm',
        props: {
            op: {
                type: String,
                required: true,

                validator(val) {
                    return ['create', 'update'].includes(val)
                }
            },

            csrf: {
                type: String,
                required: true
            },

            index: {
                type: Number
            },

            paymentMethods: {
                type: Array
            },

            paymentMethod: {
                type: Object
            }
        },
        mixins: [creditCardsValidation],

        setup() {
            const { notification } = useNotification()

            return {
                notification
            }
        },

        data: () => ({
            load: false
        }),

        watch: {
            checkCard: function (duplicate) {
                if (duplicate) {
                    this.notification('error', 'This card already exists.')
                }
            }
        },

        methods: {
            populateFormValuesOnUpdate() {
                this.cardInfo.nickname = this.paymentMethod.nickname
                    ? this.paymentMethod.nickname
                    : ''
                this.cardInfo.cardholderName = this.paymentMethod.cardholder_name
                    ? this.paymentMethod.cardholder_name
                    : ''
                this.cardInfo.expMonth = this.paymentMethod.exp_month
                    ? this.paymentMethod.exp_month
                    : ''
                this.cardInfo.expYear = this.paymentMethod.exp_year
                    ? this.paymentMethod.exp_year
                    : ''
            },

            resetFormData() {
                if (this.op === 'create') {
                    for (const input of Object.keys(this.cardInfo)) {
                        this.cardInfo[input] = ''
                    }
                } else {
                    this.populateFormValuesOnUpdate()
                }
            },
            prepCardData() {
                let cardNumber = this.prepareCardNumber(this.cardInfo.cardNumber)
                let name = this.cardInfo.cardholderName.split(' ')
                let firstName = name[0]
                let lastName = name[1]
                let data = {
                    nickname: this.cardInfo.nickname,
                    cardholder_name: this.cardInfo.cardholderName,
                    card_number: cardNumber,
                    exp_date: this.cardInfo.expDate,
                    cvc: this.cardInfo.cvc,
                    first_name: firstName,
                    last_name: lastName
                }
                return data
            },
            //@TODO remove hardcode from card edit
            // prepAjaxData(data, update = false) {
            //     let ajaxData = JSON.parse(JSON.stringify(data))

            //     if (update) ajaxData.card_number = '4242424242424242'
            //     ajaxData.exp_date = `${ajaxData.exp_month}/${ajaxData.exp_year.slice(-2)}`

            //     delete ajaxData.exp_month
            //     delete ajaxData.exp_year

            //     return ajaxData
            // },
            validationExistCard(payments) {
                this.checkCard = payments.some(
                    (card) => card.last_four === this.cardInfo.last_four
                )
                return this.checkCard
            },
            validateInputs(update = false) {
                this.validationCardHolder()
                this.validationExpDate()
                this.validationCVC()
                if (!update) this.validationCardNumber()
            },
            async handleStoreCard() {
                if (
                    this.validationPass(this.validateRules) &&
                    !this.validationExistCard(this.paymentMethods)
                ) {
                    let postData = this.prepCardData()

                    try {
                        this.load = true
                        let resp = await axios.post(
                            '/api/profile/payment-details/new',
                            postData
                        )
                        this.resetFormData()
                        this.$emit('clicked-form-submit', 'create')

                        return resp
                    } catch (e) {
                        this.notification('error', e.response?.data?.message)
                    } finally {
                        this.load = false
                    }
                } else {
                    this.notification('error', 'UI validation Error')
                }
            },
            async handleUpdateCard() {
                if (this.validationPass(this.validateRules)) {
                    let putData = this.prepCardData()

                    try {
                        this.laod = true
                        let resp = await axios.put(
                            `/profile/payment-details/${this.paymentMethod.id}`,
                            putData
                        )
                        this.resetFormData()
                        this.$emit('clicked-form-submit', 'update:' + this.index.toString())

                        return resp
                    } catch (e) {
                        this.notification('error', e.response?.data?.message)
                    } finally {
                        this.load = false
                    }
                } else {
                    this.notification('error', 'UI validation Error')
                }
            },
            async handleSubmit() {
                if (this.op === 'create') {
                    this.validateInputs()
                    await this.handleStoreCard()
                } else {
                    this.validateInputs(true)
                    await this.handleUpdateCard()
                }
            },

            handleCancel() {
                this.resetFormData()

                if (this.op === 'create') {
                    return this.$emit('clicked-form-cancel', 'create')
                }

                return this.$emit('clicked-form-cancel', 'update:' + this.index.toString())
            },
            getFirstLast() {
                const names = this.cardInfo.cardholderName.split(' ')
                this.cardInfo.firstName = names[0].toString()
                if (names[1].length) return (this.cardInfo.lastName = names[1].toString())
                else return this.cardInfo.lastName === 'default'
            }
        },
        mounted() {
            if (this.op === 'update') {
                this.populateFormValuesOnUpdate()
            }
        }
    }
</script>
<style lang="scss" scoped>
    $small: 320px;
    $medium: 768px;
    .payment-method-form-container {
        margin-top: 20px;

        .invalid-feedback {
            margin-left: 20px;
        }

        .server-error {
            color: #dc3545;
            font-size: 0.875em;
            margin-top: 0.25rem;
            margin-left: 0.75rem;
        }
        .input-border {
            border: 1px solid #ffffff63;
        }
        .error-field {
            border: 1px solid #ca2121;
        }
        .card-meta-fields {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 16px;

            .exp-month-input {
                order: 1;
                flex-basis: 175px;

                input {
                    width: 355px;
                    padding-left: 20px;
                    background: none;
                    color: #8d8d96;
                }
            }

            .exp-year-input {
                order: 2;
                flex-basis: 175px;

                input {
                    width: 165px;
                    padding-left: 20px;
                }
            }

            .card-cvc-input {
                order: 3;
                flex-basis: 100px;

                input {
                    width: 127px;
                    padding-left: 20px;
                }
            }
        }

        .save-card-btn {
            display: inline-flex;
            padding: 16px 48px;
            justify-content: center;
            align-items: center;
            gap: 16px;
            border-radius: 100px;
            background: #d7eb5a;
            border: none;
            .save-card-text {
                color: #161616;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
            }
        }

        .cancel-btn {
            display: inline-flex;
            padding: 16px 48px;
            justify-content: center;
            align-items: center;
            gap: 16px;
            border-radius: 100px;
            border: 1px solid #cdeb09;
            background: #161618;
            .cancel-text {
                color: #cdeb09;
                font-family: Inter;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
            }
        }
    }

    input {
        max-width: 498px;
        margin-top: 20px;
        padding: 16px 24px;
        border-radius: 100px;
        border: 1px solid #8d8d96;
        background: #151517;
        color: #8d8d96;

        input::placeholder {
            color: #8d8d96;
            text-align: center;
            font-family: Inter;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
        }
    }

    @media screen and (min-width: $small) and (max-width: $medium) {
        /* CardFormStyles */
        .payment-method-form-container {
            margin-top: 20px;
            font-size: 10px;

            .card-meta-fields {
                display: block;
                margin-right: 12px;

                .exp-month-input {
                    input {
                        width: 250px;
                        padding-left: 40px;
                    }
                }

                .exp-year-input {
                    input {
                        width: 250px;
                        padding-left: 40px;
                    }
                }

                .card-cvc-input {
                    input {
                        width: 250px;
                        padding-left: 40px;
                    }
                }
            }

            .save-card-btn {
                height: 40px;
                margin-left: 10px;
                margin-top: 20px;
                width: 100px;
                border: none;
            }

            .cancel-btn {
                height: 40px;
                width: 100px;
                margin-left: 35px;
                margin-top: 20px;
            }
        }

        input {
            width: 250px;
            height: 40px;
            border: 0.5px solid black;
            border-radius: 50px;
            margin-top: 20px;
            padding-left: 40px;
        }
    }
</style>
